import { BsModalRef, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Disease, PetDetail, PetType, RegistrationPetDetail, RegistrationPetDialogResult, Vaccine } from '../../interfaces/pet';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { getFormData, logFormData } from 'src/app/utils/form-util';

import { DataMappingService } from 'src/app/services/data-mapping.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { OwnerDetail } from 'src/app/interfaces/owner';
import { PetService } from 'src/app/services/pet.service';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

// import { KycService } from 'src/app/services/kyc/kyc-service';
// import { WinNotificationService } from 'src/app/services/win-notification.service';

@Component({
  selector: 'app-registration-pet-detail-dialog',
  templateUrl: './registration-pet-detail-dialog.component.html',
  styleUrls: ['./registration-pet-detail-dialog.component.scss']
})
export class RegistrationPetDetailDialogComponent implements OnInit {
  // @ViewChild('newModal') public newModal: ModalDirective;
  modalRef: BsModalRef;
  // selectedPet: any;
  title?: string;
  closeBtnName?: string;
  isNew = false;
  petDetailForm: FormGroup;
  petDetailData = new FormData();
  ownerList: OwnerDetail[] = [];
  ownerNameList: string[] = [];
  ownerFirstNameList: string[] = [];
  ownerLastNameList: string[] = [];
  isOwnerListLoaded = false;
  selectedOwner = {} as OwnerDetail;
  diseases: Disease[] = [];
  availableDiseases: Disease[] = [];
  selectedDisease = {} as Disease;
  vaccines: Vaccine[] = [];
  availableVaccines: Vaccine[] = [];
  selectedVaccine = {} as Vaccine;

  selectedDiseases = [] as Disease[];
  selectedVaccines = [] as Vaccine[];
  isSavingPet = false;

  petTypes = [] as PetType[];
  selectedPetType = {} as PetType;
  selectedRegistrationPetDetail = {} as RegistrationPetDetail;

  public onClose= new Subject<RegistrationPetDialogResult | null>();
  nationalityList: string[] = [];
  selectedNationality= '';
  selectedVaccinationProofFile: File | null = null;
  vaccinationProofUrl = '';
  selectedReferral= '';
  selectedSex = '';
  selectedIsFriendly = '';
  selectedIsSensitiveBodyOrPhysicalRestriction = '';
  selectedIsSkinProblems = '';
  selectedIsTicksFleesTreated = '';
  selectedIsRecentlyDeWormed = '';
  selectedIsSpecialDietaryRequirements = '';
  selectedIsIllLast30Days = '';
  selectedIsMedicalConditionsInjuriesIllnesses = '';
  selectedIsAllergiesFoodSensitivities = '';


  constructor(
    private petService: PetService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private jsonDataService: JsonDataService,
    private dataMappingService: DataMappingService,
  ) {
    // this.createPetDetailForm();
    this.nationalityList = this.jsonDataService.jsonNationality;
    this.petDetailForm = this.formBuilder.group({
      petType: '',
      code: '',
      name: '',
      sex: '',
      age: [''],
      breed: [''],
      isSpayedNeutered: [''],
      lastHeatDate: [''],
      isFriendly: [''],
      isSensitiveBodyOrPhysicalRestriction: [''],
      sensitiveBodyOrPhysicalRestrictionDetails: [''],
      weight: '',
      diseaseName: '',
      vaccineName: '',
      isFullyVaccinated: [''],
      vaccinatedProof: [null],
      isRabiesVaccinated: [''],
      isSkinProblems: [''],
      isTicksFleesTreated: [''],
      ticksFleesTreatedDate: [''],
      ticksFleesTreatedHowTo: [''],
      isRecentlyDeWormed: [''],
      recentlyDeWormedDate: [''],
      isSpecialDietaryRequirements: [''],
      specialDietaryRequirementsDescription: [''],
      isIllLast30Days: [''],
      illLast30DaysExplanation: [''],
      isDisplayingSymptomsCoughingSneezingUpsetStomach: [''],
      isMedicalConditionsInjuriesIllnesses: [''],
      medicalConditionsInjuriesIllnessesDetails: [''],
      isAllergiesFoodSensitivities: [''],
      allergiesFoodSensitivitiesDetails: [''],
      isAllowedPhotoVideoUsage: [''],
    });

    this.setFormFieldsSelectedValue();
    this.modalRef = bsModalRef;
  }

  ngOnInit(): void {
    this.getPetTypes();
    console.log(`Pet-detail, ngOnInit, selectedRegistrationPetDetail: ${JSON.stringify(this.selectedRegistrationPetDetail)}`);
    // this.list.push('PROFIT!!!');
    if (!this.isNew) {
      this.patchPetDetailForm(this.selectedRegistrationPetDetail);
      // if (this.selectedRegistrationPetDetail.owner) {
      //   this.selectedOwner = this.selectedRegistrationPetDetail.owner;
      // }
      // if (this.selectedPet.diseases) {
      //   this.selectedDiseases = this.selectedPet.diseases;
      // }
      // if (this.selectedPet.vaccines) {
      //   this.selectedVaccines = this.selectedPet.vaccines;
      // }
    }
  } // end of ngOnInit

  savePetDetail() {
    console.log(`savePetDetail`);
    const petData = getFormData(this.petDetailForm);
    logFormData(petData);
    const petDetail = this.dataMappingService.mapRegistrationPetDetailFormToInterface(this.petDetailForm);
    console.log(`savePetDetail, petDetails: ${JSON.stringify(petDetail)}`);

    let result: RegistrationPetDialogResult = {pet: petDetail, file: this.selectedVaccinationProofFile};
    // Hide pet information modal
    this.hideModal(result);
    // this.createPetDetailPayload();
    // console.log(`savePetDetail petDetailData: ${this.petDetailData}`);
    // if (this.isNew) {
    //   console.log(`savePetDetail create pet`);
    //   this.createPet();
    // } else {
    //   console.log(`savePetDetail update Pet`);
    //   this.updatePetDetail();
    // }
    // this.hideModal(true);
  } // end of savePetDetail

  patchPetDetailForm(pet: RegistrationPetDetail) {
    this.petDetailForm.patchValue({
      code: pet.code,
      name: pet.name,
      sex: pet.sex,
      lastHeatDate: pet.lastHeatDate,
      age: pet.age,
      breed: pet.breed,
      isSpayedNeutered: this.convertBooleanToYesNo(pet.isSpayedNeutered),
      isFriendly: this.convertBooleanToYesNo(pet.isFriendly),
      isSensitiveBodyOrPhysicalRestriction: this.convertBooleanToYesNo(pet.isSensitiveBodyOrPhysicalRestriction),
      sensitiveBodyOrPhysicalRestrictionDetails: pet.sensitiveBodyOrPhysicalRestrictionDetails,
      weight: pet.weight,
      isAllowedPhotoVideoUsage: this.convertBooleanToYesNo(pet.isAllowedPhotoVideoUsage),
      diseaseName: '',
      vaccineName: '',
      isFullyVaccinated: this.convertBooleanToYesNo(pet.healthHistory?.isFullyVaccinated),
      vaccinatedProof: pet.healthHistory?.vaccinationProof,
      isRabiesVaccinated: this.convertBooleanToYesNo(pet.healthHistory?.isRabiesVaccinated),
      isSkinProblems: this.convertBooleanToYesNo(pet.healthHistory?.isSkinProblems),
      isTicksFleesTreated: this.convertBooleanToYesNo(pet.healthHistory?.isTicksFleesTreated),
      ticksFleesTreatedDate: pet.healthHistory?.ticksFleesTreatedDate,
      ticksFleesTreatedHowTo: pet.healthHistory?.ticksFleesTreatedHowTo,
      isRecentlyDeWormed: this.convertBooleanToYesNo(pet.healthHistory?.isRecentlyDeWormed),
      recentlyDeWormedDate: pet.healthHistory?.recentlyDeWormedDate,
      isSpecialDietaryRequirements: this.convertBooleanToYesNo(pet.healthHistory?.isSpecialDietaryRequirements),
      specialDietaryRequirementsDescription: pet.healthHistory?.specialDietaryRequirementsDescription,
      isIllLast30Days: this.convertBooleanToYesNo(pet.healthHistory?.isIllLast30Days),
      illLast30DaysExplanation: pet.healthHistory?.illLast30DaysExplanation,
      isDisplayingSymptomsCoughingSneezingUpsetStomach: this.convertBooleanToYesNo(pet.healthHistory?.isDisplayingSymptomsCoughingSneezingUpsetStomach),
      isMedicalConditionsInjuriesIllnesses: this.convertBooleanToYesNo(pet.healthHistory?.isMedicalConditionsInjuriesIllnesses),
      medicalConditionsInjuriesIllnessesDetails: pet.healthHistory?.medicalConditionsInjuriesIllnessesDetails,
      isAllergiesFoodSensitivities: this.convertBooleanToYesNo(pet.healthHistory?.isAllergiesFoodSensitivities),
      allergiesFoodSensitivitiesDetails: pet.healthHistory?.allergiesFoodSensitivitiesDetails,
    });

    this.vaccinationProofUrl = `https://localhost:8000${pet.healthHistory?.vaccinationProof}`;
  } // end of patchpetDetailForm

  // updatePetDetail() {
  //   this.isSavingPet = true;
  //   // this.createPetDetailPayload();
  //   console.log(`updatePetDetail, petDetailData:${this.petDetailData}`);
  //   this.petService.updatePet(this.selectedRegistrationPetDetail.id, this.petDetailData).subscribe({
  //     next: (response) => {
  //       this.isSavingPet = false;
  //       console.log(`updatePetDetail, response: ${JSON.stringify(response)}`);
  //       // this.hideModal(true);
  //     },
  //     error: (error) => {
  //       this.isSavingPet = false;
  //       console.error(`updatePetDetail, error: ${JSON.stringify(error)}`);
  //     }
  //   });
  //   this.isSavingPet = false;
  // } // end of updatePetDetail

  createPet() {
    this.isSavingPet = true;
    // this.createPetDetailPayload();
    console.log(`createPet, petDetailData:${JSON.stringify(this.petDetailData)}`);
    this.petService.createPet(this.petDetailData).subscribe({
      next: (response) => {
        this.isSavingPet = false;
        console.log(`createPet, response: ${JSON.stringify(response)}`);
        // this.hideModal(true)
      },
      error: (error) => {
        this.isSavingPet = false;
        console.error(`createPet, error: ${JSON.stringify(error)}`);
        // this.hideModal(false)
      }
    });
    this.isSavingPet = false;
  } // end of createPet


  createPetDetailForm() {
    this.petDetailForm = this.formBuilder.group({
      code: '',
      name: '',
      ownerName: '',
      weight: '',
      disease: '',
      vaccine: ''
    });
  } // end of createpetDetailForm

  processOwnerList(response: any) {
    for (const owner of this.ownerList) {
      console.log(`processOwnerList, owner:${owner}`);
      this.ownerNameList.push(`${owner.firstName} ${owner.firstName}`);
      this.ownerFirstNameList.push(owner.firstName);
      this.ownerLastNameList.push(owner.lastName);
    }
  } // end of processOwnerList

  onSelectOwner (event: TypeaheadMatch): void{
    this.selectedOwner = event.item;
    console.log(`onSelectOwner, selectedOwner: ${JSON.stringify(this.selectedOwner)}`);
    console.log(`onSelectOwner, selectedOwner: ${this.selectedOwner.firstName} ${this.selectedOwner.lastName}`);
    this.petDetailForm.get('ownerFirstName')?.setValue(this.selectedOwner.firstName);
    this.petDetailForm.get('ownerLastName')?.setValue(this.selectedOwner.lastName);
  } // end of onSelectOwner



  onSelectOwnerFirstName (event: TypeaheadMatch): void{
    this.selectedOwner = event.item;
    console.log(`onSelectOwnerFirstName, selectedOwner: ${this.selectedOwner.firstName} ${this.selectedOwner.lastName}`);
  } // end of onSelectOwnerFirstName

  onSelectOwnerLastName (event: TypeaheadMatch): void{
    this.selectedOwner = event.item;
    console.log(`onSelectOwnerLastName, selectedOwner: ${this.selectedOwner.firstName} ${this.selectedOwner.lastName}`);
  } // end of onSelectOwnerLastName

  getPetTypes() {
    this.petService.getPetTypes().subscribe({
      next: (response) => {
        console.log(`getPetTypes, response: ${JSON.stringify(response)}`);
        this.petTypes = response;
        // this.selectedPet = this.petTypes.filter(t => t.name=='Dog')[0];
        this.selectedPetType = this.petTypes[0];
        console.log(`getPetTypes, selectedPetType: ${JSON.stringify(this.selectedPetType)}`);
        this.petDetailForm.get('petType')?.setValue(this.selectedPetType);
      },
      error: (error) => {
        console.error(`getPetTypes, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getPetTypes

  createPetDetailPayload() {
    Object.keys(this.petDetailForm.controls).forEach(
      (key) => {
        console.log(`createPetDetailPayload, key:${key}, value:${this.petDetailForm.controls[key].value}`);
        this.petDetailData.set(key, this.petDetailForm.controls[key].value);
      }
    );

    // Add owner ID to payload
    if (this.selectedOwner?.id != undefined) {
      this.petDetailData.set("owner_id", this.selectedOwner.id);
    }

    // Add pet type to payload
    this.petDetailData.set("type_id", this.selectedPetType.id);

    // Add diseases ID to payload
    this.createSelectedDiseasesPayload();
    // Add vaccines ID to payload
    this.createSelectedVaccinesPayload();
  } // end of createPetDetailPayload

  createSelectedDiseasesPayload(): void {
    for (let i = 0; i < this.selectedDiseases.length; i++) {
      this.petDetailData.append('diseases', this.selectedDiseases[i].id);
    }
  } // end of createSelectedDiseasesPayload

  createSelectedDiseasesPayload2(): string[] {
    let vaccines: string[] = [];
    this.selectedDiseases.forEach(
      (disease: Disease) =>
      {
        console.log(`createSelectedDiseasesPayload, disease:${disease.id}`);
        this.petDetailData.append("diseases", disease.id);
      }
    );

    return vaccines;
  } // end of createSelectedDiseasesPayload2

  createSelectedVaccinesPayload(): string[] {
    let vaccines: string[] = [];
    this.selectedVaccines.forEach(
      (vaccine: Vaccine) =>
      {
        console.log(`createSelectedVaccinesPayload, vaccine:${vaccine.id}`);
        this.petDetailData.append("vaccines", vaccine.id);
      }
    );

    return vaccines;
  } // end of createSelectedVaccinesPayload

  createAddVaccinePayload(): any {
    return {
      "name": this.petDetailForm.controls['vaccineName'].value,
      "note": this.petDetailForm.controls['vaccineName'].value
    }
  } // end of createAddVaccinePayload

  createAddDiseasePayload(): any {
    return {
      "name": this.petDetailForm.controls['diseaseName'].value,
      "note": this.petDetailForm.controls['diseaseName'].value
    }
  } // end of createAddDiseasePayload

  hideModal(result: RegistrationPetDialogResult | null) {
    this.onClose.next(result);
    this.bsModalRef.hide();
  } // end of hideModal

  closeModal() {
    this.hideModal(null);
  } // end of hideModal

  onSubmit() {
    console.log(`onSubmit`);
  }

  onSelectNationality (event: TypeaheadMatch): void{
    this.selectedNationality = event.item;
    console.log(`onSelectNationality, selectedNationality:${this.selectedNationality}`);
  } // end of onSelectNationality

  onVaccinationProofSelected(event: any) {
    this.selectedVaccinationProofFile = event.target.files[0];
  }

  convertBooleanToYesNo(val: boolean | null): 'yes' | 'no' | null {
    return (val!=null? val===true? 'yes': 'no' : null)
  }

  setFormFieldsSelectedValue() {
    this.petDetailForm.get('howDidYouHearAboutGoodPet')?.valueChanges.subscribe(value => {
      this.selectedReferral = value;
    });

    this.petDetailForm.get('sex')?.valueChanges.subscribe(value => {
      console.log(`sex chang, value: ${value}`);
      this.selectedSex = value;
      console.log(`sex chang, value: ${value}, selectedSex: ${this.selectedSex}`);
    });

    this.petDetailForm.get('isFriendly')?.valueChanges.subscribe(value => {
      console.log(`isFriendly chang, value: ${value}`);
      this.selectedIsFriendly = value;
      console.log(`isFriendly chang, value: ${value}, selectedIsFriendly: ${this.selectedIsFriendly}`);
    });

    this.petDetailForm.get('isSensitiveBodyOrPhysicalRestriction')?.valueChanges.subscribe(value => {
      console.log(`isSensitiveBodyOrPhysicalRestriction chang, value: ${value}`);
      this.selectedIsSensitiveBodyOrPhysicalRestriction = value;
      console.log(`isSensitiveBodyOrPhysicalRestriction chang, value: ${value}, selectedIsSensitiveBodyOrPhysicalRestriction: ${this.selectedIsSensitiveBodyOrPhysicalRestriction}`);
    });

    this.petDetailForm.get('isSkinProblems')?.valueChanges.subscribe(value => {
      console.log(`isSkinProblems chang, value: ${value}`);
      this.selectedIsSkinProblems = value;
      console.log(`isSkinProblems chang, value: ${value}, selectedIsSkinProblems: ${this.selectedIsSkinProblems}`);
    });

    this.petDetailForm.get('isTicksFleesTreated')?.valueChanges.subscribe(value => {
      console.log(`isTicksFleesTreated chang, value: ${value}`);
      this.selectedIsTicksFleesTreated = value;
      console.log(`isTicksFleesTreated chang, value: ${value}, selectedIsTicksFleesTreated: ${this.selectedIsTicksFleesTreated}`);
    });

    this.petDetailForm.get('isRecentlyDeWormed')?.valueChanges.subscribe(value => {
      console.log(`PetIsRecentlyDeWormed chang, value: ${value}`);
      this.selectedIsRecentlyDeWormed = value;
      console.log(`isRecentlyDeWormed chang, value: ${value}, selectedIsRecentlyDeWormed: ${this.selectedIsRecentlyDeWormed}`);
    });

    this.petDetailForm.get('isSpecialDietaryRequirements')?.valueChanges.subscribe(value => {
      console.log(`isSpecialDietaryRequirements chang, value: ${value}`);
      this.selectedIsSpecialDietaryRequirements = value;
      console.log(`isSpecialDietaryRequirements chang, value: ${value}, selectedIsSpecialDietaryRequirements: ${this.selectedIsSpecialDietaryRequirements}`);
    });

    this.petDetailForm.get('isIllLast30Days')?.valueChanges.subscribe(value => {
      console.log(`isIllLast30Days chang, value: ${value}`);
      this.selectedIsIllLast30Days = value;
      console.log(`isIllLast30Days chang, value: ${value}, selectedPetIsIllLast30Days: ${this.selectedIsIllLast30Days}`);
    });

    this.petDetailForm.get('isMedicalConditionsInjuriesIllnesses')?.valueChanges.subscribe(value => {
      console.log(`isMedicalConditionsInjuriesIllnesses chang, value: ${value}`);
      this.selectedIsMedicalConditionsInjuriesIllnesses = value;
      console.log(`isMedicalConditionsInjuriesIllnesses chang, value: ${value}, selectedIsMedicalConditionsInjuriesIllnesses: ${this.selectedIsMedicalConditionsInjuriesIllnesses}`);
    });

    this.petDetailForm.get('isAllergiesFoodSensitivities')?.valueChanges.subscribe(value => {
      console.log(`isAllergiesFoodSensitivities chang, value: ${value}`);
      this.selectedIsAllergiesFoodSensitivities = value;
      console.log(`isAllergiesFoodSensitivities chang, value: ${value}, selectedIsAllergiesFoodSensitivities: ${this.selectedIsAllergiesFoodSensitivities}`);
    });
  }
}
